export default __webpack_public_path__ + "static/rail-fbf658a46c5dea68811fe0f7c85f6f97.mp3";